import { render, staticRenderFns } from "./FileCom.vue?vue&type=template&id=8b3f0f62&scoped=true&"
import script from "./FileCom.vue?vue&type=script&lang=js&"
export * from "./FileCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3f0f62",
  null
  
)

export default component.exports